import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import App from "./CommonApp";

const root = document.getElementById("root");

if (root) {
    ReactDOM.createRoot(root).render(
        <HashRouter>
            <App />
        </HashRouter>
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
